import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/utils/storage/storage.service'

import { AuthService } from 'src/app/services/auth.service'
import { environment } from 'src/environments/environment'
import { PermissionsService } from './services/permissions.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'urbanism-operator';
	constructor(
		private route: ActivatedRoute,
		private storageService: StorageService,
		private authService: AuthService
	) { }

	ngOnInit() {
	}

	ngAfterViewInit() {
		// var self = this
		// this.route.queryParams.subscribe(async params => {
		// 	const token = await params['token'];
		// 	console.log('token here:', token)
		// 	if (token !== null || token !== '') {
		// 		console.log('Token:', token);
		// 		// Now you have the token, you can use it to communicate with your server
		// 		self.authService.checkTokenApp(token)
		// 	} else {
		// 		// no token, please check if our token from the storage is valid
		// 		console.log('token not found, please redirect?')
		// 		// window.location.href = environment.interop.authCore.linkRedirectAuth
		// 	}
		// });
	}

}
